import type { ApiFailure } from "../contracts";

export interface ApiErrorOptions {
  status: number;
  code: string;
  message: string;
  requestId?: string | null;
  cause?: unknown;
}

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly requestId: string | null;

  constructor(options: ApiErrorOptions) {
    super(options.message, options.cause === undefined ? undefined : { cause: options.cause });
    this.name = "ApiError";
    this.status = options.status;
    this.code = options.code;
    this.requestId = options.requestId ?? null;
  }

  static fromFailure(status: number, failure: ApiFailure): ApiError {
    return new ApiError({
      status,
      code: failure.error.code,
      message: failure.error.message,
      requestId: failure.error.requestId
    });
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}
